import Button from 'Components/@Base/Button/Button';

export default Button;
